var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivateDark(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6513_59764)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6513_59764",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.185547 0.0312519H24.1855V24.0312H0.185547V0.0312519Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6513_59764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3976 11.7567C13.7637 12.1228 14.3573 12.1228 14.7234 11.7567C15.0896 11.3906 15.0896 10.797 14.7234 10.4309C14.3573 10.0647 13.7637 10.0647 13.3976 10.4309C13.0315 10.797 13.0315 11.3906 13.3976 11.7567Z",
    fill: "#565556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.498 20.4688H4.87305C2.80197 20.4688 1.12305 18.7898 1.12305 16.7188V5.46875C1.12305 3.39767 2.80197 1.71875 4.87305 1.71875H19.498C21.5691 1.71875 23.248 3.39767 23.248 5.46875V16.7188C23.248 18.7898 21.5691 20.4688 19.498 20.4688Z",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87305 22.3438V20.4688",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.498 20.4688V22.3438",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87305 5.46875V7.34375",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8105 11.0938C17.8105 13.1648 16.1316 14.8438 14.0605 14.8438C11.9895 14.8438 10.3105 13.1648 10.3105 11.0938C10.3105 9.02267 11.9895 7.34375 14.0605 7.34375C16.1316 7.34375 17.8105 9.02267 17.8105 11.0938Z",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0605 5.46875V7.34375",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0605 14.8438V16.7188",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18945 8.28125L10.8132 9.21875",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3086 12.9688L18.9324 13.9062",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18945 13.9062L10.8132 12.9688",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3086 9.21875L18.9324 8.28125",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87305 14.8438V16.7188",
    stroke: "#565556",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6513_59764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.185547 0.03125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateDark);
export default __webpack_public_path__ + "static/media/privateDark.7a5aad7c8213132ed75b9125af461185.svg";
export { ForwardRef as ReactComponent };